










import { Component, Vue } from 'vue-property-decorator'
import { QueryParam, ColumnType } from '@/api/model/DefaultPageEntity'
import { translate } from '@/utils/filters'
import DefaultVuePage from '@/components/common/DefaultVuePage.vue'
import GenerateScreenshotDialog from '@/components/common/GenerateScreenshotDialog.vue'
import $Api from '@api'
import { finalize } from 'rxjs/operators'
import { UtilsIndex } from '@/utils'
import { canGeneratePayoutReceipt } from '@/utils/payout-receipt'

@Component({
    components: {
        DefaultVuePage,
        GenerateScreenshotDialog
    }
})
export default class LendingDetail extends Vue {
    tableLoading = false
    externalParam: any = { current: 1, size: 10, outcomeId: '', cameraId: '' }
    generateParam: any = { id: '', amount: '', name: '', cbu: '', cuit: '', coelsaId: '', transactionId: '' }
    ListColumn = [
        { prop: 'id', columnName: 'ID' },
        { prop: 'mid', columnName: 'mid' },
        { prop: 'channelName', columnName: translate('channel.channelName') as string },
        { prop: 'rtcode', columnName: translate('returnCode.name') as string },
        { prop: 'rtmsg', columnName: translate('returnCode.returnMsg') as string },
        { prop: 'cuit', columnName: 'cuit' },
        { prop: 'payStatusDesc', columnName: translate('channel.payStatus') as string },
        { prop: 'thirdSerialNo', columnName: translate('callRecord.filter.serialId') as string },
        { prop: 'amount', columnName: translate('outcome.amount') as string },
        { prop: 'createTime', columnName: translate('typeList.filter.time') as string, columnType: ColumnType.DATE },
        { prop: 'updateTime', columnName: translate('sales.updateTime') as string, columnType: ColumnType.DATE },
        { prop: 'operate', columnName: translate('sales.operation') as string, events: [
            {
                label: translate('sales.generateScreenshot') as string,
                labelIsProp: false,
                show: canGeneratePayoutReceipt
            }
        ]}
    ]
    show = false

    receiptData = {}
    private detail = {}

    created() {
        this.externalParam.outcomeId = this.$route.query.id
        this.externalParam.cameraId = this.$route.query.cameraId
        this.generateParam.id = this.$route.query.id
        this.generateParam.amount = this.$route.query.amount
        this.generateParam.name = this.$route.query.name
        this.generateParam.cbu = this.$route.query.cbu
        this.generateParam.cuit = this.$route.query.cuit
    }

    async getDetailList(param: QueryParam) {
        this.tableLoading = true
        $Api.receiptService
            .outcomeDetailList(param)
            .pipe(
                finalize(() => {
                    this.tableLoading = false
                })
            )
            .subscribe(data => {
                data.list = data.list.map((item: { cuit: string }) => {
                    item.cuit = this.generateParam.cuit
                    return item
                })
                this.detail = data
            })
    }

    onColumnEvent(detail) {
        let objData = {
            ...this.generateParam,
            amount: UtilsIndex.formatARSCompat(this.generateParam.amount),
            time: UtilsIndex.formatDateTimeHs(detail.data.updateTime),
            coelsaId: detail.data.thirdSerialNo,
            transactionId: UtilsIndex.generateSeed9(detail.data.id)
        }
        if (UtilsIndex.hasEmptyValue(objData)) {
            this.$notify.error(translate('sales.toast') as string)
            return
        }
        this.receiptData = {
            ...this.receiptData,
            ...objData
        }
        this.show = true
    }
}
